import React, { useEffect, useState } from "react";
import CustomBreadcrumb from "../../Components/CustomBreadcrumb";
import constants from "../../Utils/constants";
import MetricCategoryTreeView from "./MetricCategoryTreeView";
import { MasterServices } from "../../Services/Master";
import "../V2/SegmentGroups/CreateMetricsRule.css";
import { useHistory } from "react-router-dom";
import Toast from "../../Utils/Toast";
import { formatRoute } from "react-router-named-routes";
import GroupCategoryTreeView from "./GroupCategoryTreeView";
import { buildHierarchy } from "./CommonFunctions";

function CreateMetricsRules() {
  const history = useHistory();

  const [lobsTree, setLobTree] = useState([]);
  const [geosTree, setGeoTree] = useState([]);
  const [verticalsTree, setVerticalTree] = useState([]);
  const [metricsTree, setMetricTree] = useState([]);
  const [lobsCheckedIds, setLobCheckedIds] = useState([]);
  const [geosCheckedIds, setGeoCheckedIds] = useState([]);
  const [verticalsCheckedIds, setVerticalCheckedIds] = useState([]);
  const [metricsCheckedIds, setMetricCheckedIds] = useState([]);
  const [lobsExpandIds, setLobExpandIds] = useState([]);
  const [geosExpandIds, setGeoExpandIds] = useState([]);
  const [verticalsExpandIds, setVerticalExpandIds] = useState([]);
  const [metricsExpandIds, setMetricExpandIds] = useState([]);
  const [ruleName, setRuleName] = useState("");

  // Creating this states for group and subgroups
  const [groups, setGroups] = useState([]);
  const [groupCheckedIds, setGroupCheckedIds] = useState([]);
  const [subgroups, setSubgroups] = useState([]);
  const [subgroupCheckedIds, setsubgroupCheckedIds] = useState([]);

  const breadcrumbs = () => {
    let breadcrumbs = [
      {
        title: constants.APPLICATION_ROUTE.TEMPLATE_GROUP.NAME,
        link: constants.APPLICATION_ROUTE.TEMPLATE.LIST.ROUTE,
        is_active: false,
      },
      {
        title: constants.APPLICATION_ROUTE.TEMPLATE.CREATE.NAME,
        link: null,
        is_active: true,
      },
    ];
    return breadcrumbs;
  };

  const fetchCategoryData = () => {
    // Fetch categories using MasterServices
    MasterServices.getCategories(`metric_category?active=1`).then(res => {
      // Process the response data
      let lobRes = res.data.data;

      let childrenTree = buildHierarchy(lobRes);

      let lobTree = childrenTree.filter(item => item.metric_category_type_id === 1);
      let geoTree = childrenTree.filter(item => item.metric_category_type_id === 2);
      let verticalTree = childrenTree.filter(item => item.metric_category_type_id === 3);

      setLobTree(lobTree);
      const index = geoTree.findIndex(obj => obj.name.toLowerCase() === "global");
      geoTree[index].id = null;
      const [item] = geoTree.splice(index, 1);
      geoTree.unshift(item);
      setGeoTree(geoTree);
      const verticalIndex = verticalTree.findIndex(obj => obj.name.toLowerCase() === "all industries");
      verticalTree[verticalIndex].id = null;
      const [verticalItem] = verticalTree.splice(verticalIndex, 1);
      verticalTree.unshift(verticalItem);
      setVerticalTree(verticalTree);
    });
  };

  // API Call for Getting group and subgroup data values
  const fetchGroupSubGroup = () => {
    MasterServices.getAllGroupSubGroup().then(res => {
      const groupSubGroupResponse = res.data;
      // Map the group response to an array of objects with id and label
      const groups = groupSubGroupResponse?.groups?.map(group => ({
        id: group.id,
        label: group.name,
        priority: group.priority,
      }));

      // Update state with processed group data
      setGroups(groups.sort((a, b) => (a.priority || 100) - (b.priority || 100)));

      // Map the subgroup response similarly with additional fields
      const subgroups = groupSubGroupResponse?.subGroups.map(subgroup => ({
        id: subgroup.id,
        label: subgroup.name,
        group_id: subgroup.group_id,
        lob_ids: JSON.parse(subgroup.lob_ids),
        priority: subgroup.priority,
      }));

      // Update state with processed subgroup data
      setSubgroups(subgroups.sort((a, b) => (a.priority || 100) - (b.priority || 100)));
    });
  };

  const fetchMetricsData = () => {
    MasterServices.getMetrics("metrics_v2").then(res => {
      let lobRes = res.data.data;
      let childrenTree = buildHierarchy(lobRes);
      setMetricTree(childrenTree);
    });
  };
  function getCheckedObjs(data) {
    let checkedObjects = [];

    function traverseAndFilter(arr) {
      for (let item of arr) {
        if (item.checked) {
          let id = item.id;
          let name = item.name;
          checkedObjects.push({ id, name });
        }
        if (item.children && item.children.length > 0) {
          traverseAndFilter(item.children);
        }
      }
    }

    traverseAndFilter(data);

    return checkedObjects;
  }

  const handleCreate = () => {
    const group_id = groupCheckedIds; // passing checked group ids
    const sub_group_id = subgroupCheckedIds; // passing checked sub-group ids
    let lobs = lobsCheckedIds;
    let geos = geosCheckedIds;
    let verticals = verticalsCheckedIds;
    let metrics = metricsCheckedIds;

    let input = {
      group_id,
      sub_group_id,
      rule_name: ruleName,
      lobs,
      geos,
      verticals,
      metrics,
    };

    MasterServices.addMetricRule(input)
      .then(res => {
        let resId = res.data.id;
        history.push({
          pathname: formatRoute(constants.APPLICATION_ROUTE.TEMPLATE_METRICS_VIEW.ROUTE, { id: resId }),
        });
        Toast(constants.APPLICATION_ROUTE.TEMPLATE_METRICS_VIEW.SUCCESS, "success");
        history.push("/template");
      })
      .catch(e => {
        Toast(e.data.error, "error");
      });
  };

  useEffect(() => {
    fetchCategoryData();
    fetchMetricsData();
    fetchGroupSubGroup();
  }, []);

  return (
    <aside className="main_content">
      <div className="m-3 mb-0 bg-white px-3 py-3 br_8 main_content_height">
        <div className="d-flex align-items-center flex-wrap title-section breadcrumb-mb-0">
          <CustomBreadcrumb breadcrumbs={breadcrumbs()} />
        </div>
        <div className="rule-input-div">
          <input
            placeholder="Enter rule name"
            value={ruleName}
            onChange={e => {
              setRuleName(e.target.value);
            }}
          />
        </div>
        <div style={{ display: "flex", gap: "20px", marginTop: "16px" }}>
          {/* Component for Group and Subgroup Tree View */}
          <GroupCategoryTreeView
            // Passing group data and its state setter
            groupData={groups}
            setGroupData={setGroups}
            // Passing subgroup data and its state setter
            subgroupData={subgroups}
            setSubgroupData={setSubgroups}
            // Checked group IDs and their setter
            checkedGroupIds={groupCheckedIds}
            setGroupCheckedIds={setGroupCheckedIds}
            // Checked subgroup IDs and their setter
            checkedSubgroupIds={subgroupCheckedIds}
            setSubgroupCheckedIds={setsubgroupCheckedIds}
            // Expanded LOB node IDs and their setter
            expandedIds={lobsExpandIds}
            setExpandIds={setLobExpandIds}
            // Checked LOB IDs setter (used after subgroup selection)
            setCheckedIds={setLobCheckedIds}
            // LOB tree structure and its state setter
            treeData={lobsTree}
            setTreeData={setLobTree}
            // Title to be shown in the component header
            title="Group"
            // Flag to control view mode (false means edit mode here)
            rule_view={false}
          />
          <MetricCategoryTreeView
            treeData={lobsTree}
            setTreeData={setLobTree}
            checkedIds={lobsCheckedIds}
            setCheckedIds={setLobCheckedIds}
            expandedIds={lobsExpandIds}
            setExpandIds={setLobExpandIds}
            isLobTooltip={true} // used for showing tooltip on lobs section
            title="LOB's"
            rule_view={false} // Flag to control rule view mode (false means edit mode here)
            checkedSubgroupIds={subgroupCheckedIds}
          />
          <MetricCategoryTreeView
            treeData={verticalsTree}
            setTreeData={setVerticalTree}
            checkedIds={verticalsCheckedIds}
            setCheckedIds={setVerticalCheckedIds}
            expandedIds={verticalsExpandIds}
            setExpandIds={setVerticalExpandIds}
            title="Verticals"
            rule_view={false} // Flag to control rule view mode (false means edit mode here)
          />
          <MetricCategoryTreeView
            treeData={geosTree}
            setTreeData={setGeoTree}
            title="Geography"
            checkedIds={geosCheckedIds}
            setCheckedIds={setGeoCheckedIds}
            expandedIds={geosExpandIds}
            setExpandIds={setGeoExpandIds}
            rule_view={false} // Flag to control rule view mode (false means edit mode here)
          />
          <MetricCategoryTreeView
            treeData={metricsTree}
            setTreeData={setMetricTree}
            title="Metric and Type"
            checkedIds={metricsCheckedIds}
            setCheckedIds={setMetricCheckedIds}
            expandedIds={metricsExpandIds}
            setExpandIds={setMetricExpandIds}
            isMetrics={true}
            rule_view={false} // Flag to control rule view mode (false means edit mode here)
          />
        </div>
        <div className="create-btn-div">
          <button
            className={"btn btn-custom btn-primary icon-text-btn title-btn d-inline-flex align-items-center mb-3"}
            type="button"
            onClick={handleCreate}
            disabled={
              !ruleName.length ||
              !groupCheckedIds.length ||
              !subgroupCheckedIds.length ||
              !lobsCheckedIds.length ||
              !metricsCheckedIds.length ||
              ruleName.trim() === ""
            }
          >
            Create Rule
          </button>
        </div>
      </div>
    </aside>
  );
}

export default CreateMetricsRules;
